import { render, staticRenderFns } from "./AxLayout2.vue?vue&type=template&id=ed9b2a00&scoped=true"
import script from "./AxLayout2.vue?vue&type=script&lang=ts"
export * from "./AxLayout2.vue?vue&type=script&lang=ts"
import style0 from "./AxLayout2.vue?vue&type=style&index=0&id=ed9b2a00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed9b2a00",
  null
  
)

export default component.exports